import moment from "moment";
import React from "react";

import { formatCurrency } from "util/format";

const ColumnsCashFlow = {
  paid: [
    {
      title: "Vencimento",
      dataIndex: "dueDate",
    },
    {
      title: "Fornecedor",
      dataIndex: "customer",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Categoria",
      dataIndex: "category",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Valor",
      dataIndex: "amountPaid",
      render: (text) => {
        return formatCurrency(text);
      },
    },
  ],
  receive: [
    {
      title: "Vencimento",
      dataIndex: "dueDate",
    },
    {
      title: "Cliente",
      dataIndex: "customer",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Categoria",
      dataIndex: "category",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Entrada",
      dataIndex: "amountPaid",
      render: (text) => {
        return formatCurrency(text);
      },
    },
  ],

  cashFlow: [
    {
      title: "Data",
      dataIndex: "dueDate",
      
    },
    {
      title: "Entrada",
      dataIndex: "receiveString",
    },
    {
      title: "Saida",
      dataIndex: "paidString",
    },
    {
      title: "Saldo Final",
      dataIndex: "profitString",
    },
  ],
  cashFlowDaily: [
    {
      title: "Vencimento",
      dataIndex: "dueDate",
      render: (text) => {
        let date = moment(text).format("DD/MM/YYYY");
        return date;
      },
    },
    {
      title: "Fornecedor",
      dataIndex: "customer",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Categoria",
      dataIndex: "category",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      textWrap: "word-break",
      ellipsis: true,
    },
    {
      title: "Valor",
      dataIndex: "amountPaid",
      render: (text) => {
        return formatCurrency(text);
      },
    },
  ],
};

export default ColumnsCashFlow;
